/** @format */

export const ShippingSmall = ({color}) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_476_156)">
                <path
                    d="M13.3327 5.33335H11.3327V2.66669H1.99935C1.26602 2.66669 0.666016 3.26669 0.666016 4.00002V11.3334H1.99935C1.99935 12.44 2.89268 13.3334 3.99935 13.3334C5.10602 13.3334 5.99935 12.44 5.99935 11.3334H9.99935C9.99935 12.44 10.8927 13.3334 11.9993 13.3334C13.106 13.3334 13.9993 12.44 13.9993 11.3334H15.3327V8.00002L13.3327 5.33335ZM12.9993 6.33335L14.306 8.00002H11.3327V6.33335H12.9993ZM3.99935 12C3.63268 12 3.33268 11.7 3.33268 11.3334C3.33268 10.9667 3.63268 10.6667 3.99935 10.6667C4.36602 10.6667 4.66602 10.9667 4.66602 11.3334C4.66602 11.7 4.36602 12 3.99935 12ZM5.47935 10C5.11268 9.59335 4.59268 9.33335 3.99935 9.33335C3.40602 9.33335 2.88602 9.59335 2.51935 10H1.99935V4.00002H9.99935V10H5.47935ZM11.9993 12C11.6327 12 11.3327 11.7 11.3327 11.3334C11.3327 10.9667 11.6327 10.6667 11.9993 10.6667C12.366 10.6667 12.666 10.9667 12.666 11.3334C12.666 11.7 12.366 12 11.9993 12Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_476_156">
                    <rect width="16" height="16" fill={color} />
                </clipPath>
            </defs>
        </svg>
    );
};
